module.exports = __webpack_public_path__ + "static/media/user-menu-hov.937b9624.svg";